import { jsx as c } from "react/jsx-runtime";
import { clsx as e } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useIsDocumentRTL as I } from "../../utils/use-rtl-direction.js";
import { icons as i, IconsRightToLeft as R } from "./icons.js";
import o from "./roche-icon.module.scss.js";
const D = ({
  icon: n,
  height: t,
  width: r,
  color: s,
  decorative: l = !0,
  display: m,
  onClick: a
}) => {
  const u = I();
  if (!Object.keys(i).includes(n))
    return null;
  const f = u ? R.includes(n) : !1, d = i[n], p = {
    "--custom-icon-color": s
  };
  return /* @__PURE__ */ c("span", { className: e(o["icon-container"], m === "inline" && o["icon-container--inline"]), children: /* @__PURE__ */ c(
    d,
    {
      className: e(o.icon, f && o["icon--rtl"]),
      width: r,
      height: t,
      "aria-hidden": l,
      style: s ? p : void 0,
      onClick: a
    }
  ) });
};
export {
  D as RocheUIIcon
};
